import $ from 'jquery';
import { showSidebarTab, toggleEditorSidebar } from '~src/sidebarLegacy';
import { updateObjectShadow } from '~src/sidebar/index';
import { getState } from '~src/state';

export const toggleObjectShadow = (event) => {
  event.preventDefault();
  const isSidebarOpen = getState('isSidebarOpen');
  if (isSidebarOpen) {
    toggleEditorSidebar();
  } else {
    $('#sidebar-content .tab').removeClass('active');
    showSidebarTab('object-shadow');
    updateObjectShadow();
  }
};
